import React from 'react';
// types
import { IFormFieldTypes } from '@/types/form';
// styles
import styles from './styles.module.scss';
// validations
import validations from '@/validations';
const { required, composeValidators, number, maxLength } = validations;
import { getCssVar } from '@/utils/cssVars';
import { IContentColors } from '@/types';
import api from '@/api';

const getValidations = record => {
  if (record.isRequired && record.dataType === 'LONG') {
    return composeValidators(required, number);
  } else if (record.dataType === 'LONG') {
    return composeValidators(number);
  } else if (record.isRequired) {
    return composeValidators(required);
  } else {
    return null;
  }
};

const fieldType = {
  SHORTANSWER: IFormFieldTypes.LANDING_PAGE_INPUT,
  DROPDOWN: IFormFieldTypes.SELECT,
  MULTISELECT: IFormFieldTypes.MULTISELECT,
  NUMBER: IFormFieldTypes.NUMBER,
  DATE: IFormFieldTypes.DATE,
  CHECKBOXES: IFormFieldTypes.CHECKBOXES,
};

export function getFormSectionFields(
  fields,
  cutomFieldsList,
  countryList = [],
) {
  if (cutomFieldsList && cutomFieldsList.length > 0) {
    let customFields = [] as any;
    cutomFieldsList.map(item => {
      if (item.isHidden) {
        return;
      }
      const {
        labelName,
        fieldName,
        dropdownValues,
        isPredefinedField,
        customFieldName,
      } = item;
      const dropOptions =
        fieldType[item.fieldType] === fieldType.MULTISELECT
          ? [
              {
                label: `Select ${fieldName}`,
                value: `Select ${fieldName}`,
                disabled: true,
                hidden: true,
              },
            ]
          : ([] as any);
      if (dropdownValues && dropdownValues.split(',').length > 0) {
        dropdownValues.split(',').map(item => {
          dropOptions.push({
            label: item,
            value: item,
          });
        });
      }

      if (labelName === 'country') {
        countryList &&
          countryList.map(item =>
            dropOptions.push({
              label: item.name,
              value: item.name,
            }),
          );
      }

      customFields.push({
        fields: [
          {
            // WARNING- do not change the "name" or "placeholder" unless you're
            //  sure of what you are doing!
            //
            // NOTE- the form's "name" attribute, this needs to be stripped of
            //  all special characters and spaces for the custom fields
            //  JSON. e.g. "Phone No.:" will become "PhoneNo"
            name: labelName,
            //
            // NOTE- this should be `fieldName` BUT we are using the
            //  "placeholder" for this form's UI label.
            // label: fieldName,
            //
            // NOTE- placeholder is the same as the UI field name e.g. "Phone No.:"
            // Keeping placeholder as empty string, from this issue: ENG-6368
            placeholder: '',
            label: `${customFieldName ? customFieldName : fieldName}`,
            fieldCategory: item.fieldCategory,
            fieldName: fieldName,
            fieldType:
              item.dataType === 'INTEGER'
                ? IFormFieldTypes.NUMBER
                : labelName === 'country'
                ? fieldType['DROPDOWN']
                : fieldType[item.fieldType],
            widthRatio: 1,
            data: dropOptions,
            validate: getValidations(item),
            selectStyleClass: 'landingPageSelect',
            isSearchable: labelName === 'country',
            selectStyles: {
              control: provided => ({
                ...provided,
                border: '2px solid #CDCDCD',
                fontSize: '12px',
                minHeight: '56px',
                marginTop: '-10px',
                marginBottom: '-10px',
                paddingLeft: '12px',
              }),
              menu: provided => ({
                ...provided,
                zIndex: 999999,
              }),
              singleValue: () => ({
                marginTop: '20px',
                marginLeft: '4px',
              }),
              placeholder: () => ({
                color: getCssVar(IContentColors.NEUTRAL_MID_2),
              }),
              input: provided => ({
                ...provided,
                position: 'absolute',
              }),
              valueContainer: provided => ({
                ...provided,
                paddingTop: '10px',
                paddingBottom: '10px',
                paddingLeft: '8px',
                paddingRight: '8px',
              }),
            },
          },
        ],
      });
    });
    return [...fields, ...customFields];
  } else {
    return fields;
  }
}

const PromptMessage = ({ message, setSubScription }) => {
  return (
    <div className={styles.confirmContainer}>
      <div className={styles.subscriptionContainer}>{message}</div>
      <div className={styles.selectConfirmContainer}>
        <div className={styles.selectConfirmRadioContainer}>
          <div className={styles.selectOptionConfirm}>
            <input
              className={styles.confirmRadio}
              type="radio"
              id="confirmNote"
              name="confirmNote"
              value={'YES'}
              defaultChecked
              onChange={() => setSubScription('YES')}
            />
            <div className={styles.promptMessageLabel}>Yes&nbsp;&nbsp;</div>
          </div>
          <div className={styles.selectOptionConfirm}>
            <input
              className={styles.confirmRadio}
              type="radio"
              id="confirmNote"
              name="confirmNote"
              value={'NO'}
              onChange={() => setSubScription('NO')}
            />
            <div className={styles.promptMessageLabel}>No</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromptMessage;
